import { Alert, Snackbar } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import DiscountService from "../../../services/DiscountService";
import UtilsFormule from "../../../utils/UtilsFormule";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import toastr from "toastr";
import DataTablePromo from "./DataTablePromo";

const Discounts = () => {
  const navigate = useNavigate();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const [availableDiscount, setAvailableDiscount] = useState([]);
  const [availableDeclencheurs, setAvailableDeclencheurs] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();

  const [openDisable, setOpenDisable] = useState(false);
    const [openDisableDiscount, setOpenDisableDiscount] = useState(false);

  const [declencheurId, setDeclencheurId] = useState(false);
  const [discountId, setDiscountId] = useState(false);

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  useEffect(() => {
    DiscountService.allDiscounts(getCurrentUserId(), 1, 0)
      .then((response) => {
        if (response.data.success) {
          setAvailableDiscount(response.data.success);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de dépôt");
        }
      })
      .catch((e) => {
        console.log("error in allDiscounts", e);
      });

    DiscountService.allDeclencheurs(getCurrentUserId(), 1, 0)
      .then((response) => {
        if (response.data.success) {
          console.log("response", response.data.success);
          setAvailableDeclencheurs(response.data.success);
        } else {
          setOpenInfoAlert(true);
          setInfoAlertText("Pas de Déclencheurs");
        }
      })
      .catch((e) => {
        console.log("error in allDiscounts", e);
      });
  }, []);

  const onAddPackHandler = () => {
    navigate(`/addDiscount`);
  };
  const onAddPriorityHandler = () => {
    navigate(`/addDeclencheur`);
  };

   const onUpdateDeclencheurHandler = (idDeclencheur) => {
    localStorage.setItem("idDeclencheur",idDeclencheur)
    navigate(`/updateDeclencheur`);
  };
  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const handleOpenDisable = (idDeclencheur) => {
    setOpenDisable(true);
    setDeclencheurId(idDeclencheur);
  };

const handleOpenDiscountDisable = (idDiscount) => {
    setOpenDisableDiscount(true);
    setDiscountId(idDiscount);
  };

  const handleCloseDisable = () => setOpenDisable(false);
    const handleCloseDisableDiscount = () => setOpenDisableDiscount(false);

  const handleClickDisable = async () => {
    try {
      const response = await DiscountService.desactiverDeclencheur(
        getCurrentUserId(),
        declencheurId,
        0
      );
      toastr.success(response.data.success);
      handleCloseDisable();
      window.location.reload(true);
      // console.log("Carte Cadeau disabled successfully");
    } catch (error) {
      console.error("Error disabling Carte Cadeau:", error);
    }
  };

   const handleClickDiscountDisable = async () => {
    try {
      const response = await DiscountService.desactiverDiscount(
        getCurrentUserId(),
        discountId,
        0
      );
      toastr.success(response.data.success);
      handleCloseDisable();
      window.location.reload(true);
      // console.log("Carte Cadeau disabled successfully");
    } catch (error) {
      console.error("Error disabling Carte Cadeau:", error);
    }
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3">
                <div class="card-body">
                  <h5 class="card-title">Les Rules</h5>
                  <button
                    class="btn btn-dark float-right"
                    data-toggle="modal"
                    data-target="#add-brand"
                    onClick={onAddPackHandler}
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>
              <div class="card  mt-3">
                <div class="card-body">
                  <h5 class="card-title">Les Déclencheurs</h5>
                  <button
                    class="btn btn-dark float-right"
                    data-toggle="modal"
                    data-target="#add-brand"
                    onClick={onAddPriorityHandler}
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>
              {availableDeclencheurs && (
                <section class="content">
                  <div class="card">
                    <div class="card-header">
                      <h3 class="card-title">Declencheur disponible</h3>

                      <div class="card-tools">
                        <button
                          className="btn btn-secondary  mx-1"
                          onClick={() =>
                            handleOpenDisable(availableDeclencheurs?.id)
                          }
                        >
                          <h6>
                            <small>
                              {" "}
                              <i class="fas fa-ban"></i>
                            </small>
                          </h6>
                        </button>
                         <button
                          className="btn btn-dark  mx-1"
                          onClick={() =>
                            onUpdateDeclencheurHandler(availableDeclencheurs?.id)
                          }
                        >
                          <h6>
                            <small>
                              {" "}
                              <i class="fas fa-eye"></i>
                            </small>
                          </h6>
                        </button>
                      </div>
                      <br />
                      <br />
                      {availableDeclencheurs && (
                        <p>
                          {availableDeclencheurs.refCC}-
                          {availableDeclencheurs.nameCC}
                        </p>
                      )}

                      {availableDeclencheurs && (
                        <p>
                          Du{" "}
                          {UtilsFormule.formatDate(
                            availableDeclencheurs.startDate
                          )}{" "}
                          jusqu'à{" "}
                          {UtilsFormule.formatDate(
                            availableDeclencheurs.endDate
                          )}
                        </p>
                      )}
                      <p>
                        <b>Les dépôts</b>
                      </p>
                      {availableDeclencheurs &&
                        availableDeclencheurs.warehouses.map((element, i) => (
                          <p>{element.label}</p>
                        ))}
                    </div>
                    {/* <div class="card-body p-0">
                      <table class="table  projects">
                        <thead>
                          <tr>
                            <th>Règle </th>
                            <th>Priorité</th>
                          </tr>
                        </thead>
                        <tbody>
                          {availableDeclencheurs &&
                            availableDeclencheurs.priorities.map(
                              (element, i) => (
                                <tr key={element.order}>
                                  <td>{element.discountName}</td>
                                  <td>{element.order}</td>
                                </tr>
                              )
                            )}
                        </tbody>
                      </table>
                    </div> */}
                  </div>
                </section>
              )}
              <section class="content">
                <div class="card">
                
                  <div class="card-body p-0">
                    {availableDiscount&& 
                    <DataTablePromo listPromo={availableDiscount} />}
                    {/* <table class="table  projects">
                      <thead>
                        <tr>

                          <th>Libellé</th>
                          <th>Type promotion</th>
                          <th style={{ width: "12%" }}>DC</th>

                          <th className="text-center" style={{ width: "12%" }}>
                            desactiver
                          </th>
                          
                        </tr>
                      </thead>
                      <tbody>
                        {availableDiscount &&
                          availableDiscount.map((element, i) => (
                            <tr key={element.id}>
                              <td>{element.libelle}</td>
                              {element.typeDiscount === 1 ? (
                                <td className="text-center">
                                  Promotion sur produit
                                </td>
                              ) : (
                                <td className="text-center">
                                  Promotion sur panier
                                </td>
                              )}

                              <td>
                                {UtilsFormule.formatDate(element.creationDate)}
                              </td>

                              <td className="text-center">
                               <button
                          className="btn btn-secondary  mx-1"
                          onClick={() =>
                            handleOpenDiscountDisable(element?.id)
                          }
                        >
                          <h6>
                            <small>
                              {" "}
                              <i class="fas fa-ban"></i>
                            </small>
                          </h6>
                        </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table> */}
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>

      <Dialog open={openDisable} onClose={handleCloseDisable}>
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Voulez-vous désactiver ce declencheur ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDisable} color="primary">
            Annuler
          </Button>
          <Button onClick={handleClickDisable} color="error">
            Confirmer
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openDisableDiscount} onClose={handleCloseDisableDiscount}>
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Voulez-vous désactiver cette promotion ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDisableDiscount} color="primary">
            Annuler
          </Button>
          <Button onClick={handleClickDiscountDisable} color="error">
            Confirmer
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default Discounts;
